export const messages = {
  termsOfUse: {
    id: 'footer.TermsOfUse',
    defaultMessage: 'Terms Of Use',
  },
  privacyStatement: {
    id: 'footer.PrivacyStatement',
    defaultMessage: 'Privacy Statement',
  },
  accessibilityHelp: {
    id: 'footer.AccessibilityHelp',
    defaultMessage: 'Accessibility Help',
  },
  closeModalText: {
    id: 'footer.CloseModalText',
    defaultMessage: 'Close',
  },
  screenReader: {
    termsOfUse: {
      id: 'screenReader.TermsOfUse',
      defaultMessage: 'Terms of use link clicking opens a new tab',
    },
    privacyStatement: {
      id: 'screenReader.PrivacyStatement',
      defaultMessage: 'Privacy statement link clicking opens a new tab',
    },
    accessibilityHelp: {
      id: 'screenReader.AccessibilityHelp',
      defaultMessage: 'Accessibility help link clicking opens a new tab',
    },
  },
};
